export enum Direction {
  TB, RL, BT, LR
}
